import './index.css';
import './services/telemetry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider, useIsAuthenticated } from '@azure/msal-react';
import { msalInstance } from './services/msalConfig';
import App from './App';
import { AccessDenied } from './pages/AccessDenied';

const AccessDeniedRoute: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <AccessDenied />;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <Routes>
          <Route path="/access-denied" element={<AccessDeniedRoute />} />
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
